export const ACTIVATE_TRUELAYER = 'ACTIVATE_TRUELAYER';
export const FETCH_TRUELAYER_URL = 'FETCH_TRUELAYER_URL';
